/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./OrgSetupConfirm.css";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { PLATFORM } from "../../../config";

class OrgSetupConfirm extends Component {
  render() {
    const languageObj = this.props.languageObj;
    return (
      <div className="OrgSetupConfirm-view">
        <div className="OrgSetupConfirm-center">
          <div className="OrgSetupConfirm-header">
            {/* Conditionally render logo based on platform */}
            <div
              className={
                PLATFORM === "plug"
                  ? "OrgSetupConfirm-PlugLogo"
                  : "OrgSetupConfirm-CheckPlusLogo"
              }
            />

            {/* Only show the 'check back' message if not plug platform */}
            {PLATFORM !== "plug" ? (
              <div className="OrgSetupConfirm-steps">{languageObj.step}</div>
            ) : (
              <div className="OrgSetupConfirm-steps">
                Your account setup is complete!
              </div>
            )}

            <div className="OrgSetupConfirm-buttonsContainer">
              {/* Only show the edit button if not plug platform */}
              {PLATFORM !== "plug" && (
                <div
                  className="OrgSetupConfirm-editBtn"
                  onClick={this.props.editBtn}
                >
                  <div className="OrgSetupConfirm-editIcn" />
                </div>
              )}

              <div
                className="OrgSetupConfirm-logoutContainer"
                onClick={this.props.orgLogout}
              >
                <div className="OrgSetupConfirm-logoutIcon" />
              </div>
            </div>
          </div>

          <div className="OrgSetupConfirm-centerContainer">
            <div className="OrgSetupConfirm-prompt">
              <div className="OrgSetupConfirm-documentContainer">
                <div className="OrgSetupConfirm-documentIcn"></div>
                <div className="OrgSetupConfirm-heading">
                  {languageObj.text1}
                </div>
                <div className="OrgSetupConfirm-text">{languageObj.text2}</div>
                <div className="OrgSetupConfirm-completedIcn" />
              </div>
            </div>

            <div className="OrgSetupConfirm-spaceInBetween"></div>

            <div className="OrgSetupConfirm-prompt">
              <div className="OrgSetupConfirm-loginContainer">
                <div className="OrgSetupConfirm-mailVerifyIcn"></div>
                <div className="OrgSetupConfirm-heading">
                  {languageObj.text3}
                </div>
                <div className="OrgSetupConfirm-completedIcn" />
              </div>
            </div>
            <div className="OrgSetupConfirm-spaceInBetween"></div>

            <div className="OrgSetupConfirm-prompt">
              <div className="OrgSetupConfirm-loginContainer">
                <div className="OrgSetupConfirm-documentIcn"></div>
                <div className="OrgSetupConfirm-heading">
                  {languageObj.text4}
                </div>
                <div className="OrgSetupConfirm-text">{languageObj.text5}</div>
                <div className="OrgSetupConfirm-completedIcn" />
              </div>
            </div>

            <div className="OrgSetupConfirm-spaceInBetween"></div>

            {/* Show different messages based on platform */}
            {PLATFORM === "plug" ? (
              <div className="OrgSetupConfirm-promptBlue">
                <div className="OrgSetupConfirm-loginContainer">
                  <div className="OrgSetupConfirm-checklistIcn"></div>
                  <div className="OrgSetupConfirm-headingWhite">
                    Welcome to Plug! Your account is ready to use.
                  </div>
                  <Link to="/OrgLogin">
                    <div className="OrgSetupConfirm-signInBtn">
                      <div className="OrgSetupConfirm-signInText">
                        Sign In Now
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            ) : (
              <div className="OrgSetupConfirm-promptBlue">
                <div className="OrgSetupConfirm-loginContainer">
                  <div className="OrgSetupConfirm-checklistIcn"></div>
                  <div className="OrgSetupConfirm-headingWhite">
                    {languageObj.text6}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
OrgSetupConfirm.propTypes = {
  orgLogout: PropTypes.func,
  editBtn: PropTypes.func,
  languageObj: PropTypes.object,
};
export default OrgSetupConfirm;
